import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import GoogleSpreadsheetWriterForm from '../forms/google-spreadsheet-writer-form';
import { googleSpreadsheetWriterValidationSchema } from '../schema/googleSpreadsheetWriter.js';

export default function GoogleSpreadsheetWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Google Spreadsheet Writer Node Details',
        altText: 'Google Spreadsheet Writer Node',
        defaultLabel: 'Google Spreadsheet Writer Node',
      }}
    >
      <CommonNode
        FormComponent={GoogleSpreadsheetWriterForm}
        schemaResolver={googleSpreadsheetWriterValidationSchema}
      />
    </NodeProvider>
  );
}
